import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { commonItems } from "./Jsonsidebar";
import { useTheme } from "./Theme/Themecontext";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";
import Loader from "../common/Loader";

const Sidebar = () => {
  const { t, i18n } = useTranslation();

  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD;

  const baseUrl1 =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV_1
      : process.env.REACT_APP_BASE_URL_PROD_1;

  const { styles } = useTheme();
  const { sidebarborder, Svgcolor } = styles;
  const token = localStorage.getItem("Mandoobee-token");
  const userInfo = jwtDecode(token);

  const [selectedItem, setSelectedItem] = useState(null);
  const [routes, setRoutes] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const userRole = userInfo.role;

  const GetRoutes = () => {
    try {
      fetch(`${baseUrl}/org`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch organization data");
          }
          return response.json();
        })
        .then((data) => {
          if (data.isSuccess) {
            const options = data.result?.options || [];
            const filteredOptions = options.filter((option) => {
              return option.access.includes(userRole);
            });

            setRoutes(filteredOptions);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          console.error("Error fetching organization data:", err);
          setError("Error in fetching organization data: " + err);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
      setError("Failed to fetch organization data: " + error);
    }
  };

  useEffect(() => {
    GetRoutes();
  }, []);



  const Omitted = ["Service\nManagement", "IOT", "App Config", "My Report","AI Contract\nReview","AI Contract\nDraft"];

  const iconFill = [
    "icons/svg/mandoobee_bot.svg",
    "icons/svg/pdfgenerator.svg",
    "icons/svg/announcement.svg",
    "icons/svg/payroll.svg",
  ];

  // Home route definition
  const homeRoute = {
    name: "Home",
    arName: "الرئيسية",
    path: "",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.02 2.84016L3.63 7.04016C2.73 7.74016 2 9.23016 2 10.3602V17.7702C2 20.0902 3.89 21.9902 6.21 21.9902H17.79C20.11 21.9902 22 20.0902 22 17.7802V10.5002C22 9.29016 21.19 7.74016 20.2 7.05016L14.02 2.72016C12.62 1.74016 10.37 1.79016 9.02 2.84016Z"
          stroke="#FEFEFE"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 17.9902V14.9902"
          stroke="#FEFEFE"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  };

  const SmartItSupport = {
    name: "Smart IT Support",
    arName: "دعم تكنولوجيا المعلومات الذكية",
    path: "/itsupportmanager",
    icon: (
        <svg
          width="24"
          height="22"
          viewBox="0 0 25 23"
          fill="white"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.2308 21.6249V19.75H20.3653C20.4695 19.75 20.5597 19.7179 20.6358 19.6538C20.7119 19.5897 20.75 19.5056 20.75 19.4014V10.6586C20.75 8.26918 19.895 6.25756 18.1851 4.62375C16.4751 2.98996 14.4134 2.17306 12 2.17306C9.58651 2.17306 7.52481 2.98996 5.81487 4.62375C4.10494 6.25756 3.24997 8.26918 3.24997 10.6586V18.0192H2.3125C1.71315 18.0192 1.19873 17.8104 0.76925 17.393C0.33975 16.9755 0.125 16.4671 0.125 15.8678V13.4399C0.125 13.0344 0.240386 12.663 0.471156 12.3257C0.701927 11.9884 1.00321 11.7171 1.375 11.512L1.43272 9.91584C1.53526 8.55528 1.88861 7.29488 2.49278 6.13463C3.09695 4.97436 3.87178 3.96433 4.81728 3.10456C5.7628 2.24479 6.85415 1.57493 8.09131 1.09497C9.3285 0.61499 10.6314 0.375 12 0.375C13.3686 0.375 14.6682 0.61499 15.899 1.09497C17.1298 1.57493 18.2211 2.24159 19.173 3.09497C20.125 3.94832 20.8998 4.95513 21.4975 6.11538C22.0953 7.27563 22.4518 8.53604 22.5672 9.89663L22.6249 11.4615C22.9887 11.633 23.288 11.8782 23.5228 12.1971C23.7575 12.516 23.8749 12.8718 23.8749 13.2644V16.0553C23.8749 16.4479 23.7575 16.8036 23.5228 17.1225C23.288 17.4415 22.9887 17.6866 22.6249 17.8581V19.4014C22.6249 20.0168 22.4042 20.5412 21.9627 20.9747C21.5212 21.4082 20.9887 21.6249 20.3653 21.6249H11.2308ZM8.49038 13.2115C8.18429 13.2115 7.92348 13.1077 7.70794 12.9002C7.4924 12.6927 7.38463 12.4359 7.38463 12.1298C7.38463 11.8237 7.4924 11.5649 7.70794 11.3533C7.92348 11.1418 8.18429 11.036 8.49038 11.036C8.79646 11.036 9.05727 11.1418 9.27281 11.3533C9.48835 11.5649 9.59613 11.8237 9.59613 12.1298C9.59613 12.4359 9.48835 12.6927 9.27281 12.9002C9.05727 13.1077 8.79646 13.2115 8.49038 13.2115ZM15.5096 13.2115C15.2035 13.2115 14.9427 13.1077 14.7271 12.9002C14.5116 12.6927 14.4038 12.4359 14.4038 12.1298C14.4038 11.8237 14.5116 11.5649 14.7271 11.3533C14.9427 11.1418 15.2035 11.036 15.5096 11.036C15.8156 11.036 16.0765 11.1418 16.292 11.3533C16.5075 11.5649 16.6153 11.8237 16.6153 12.1298C16.6153 12.4359 16.5075 12.6927 16.292 12.9002C16.0765 13.1077 15.8156 13.2115 15.5096 13.2115ZM4.96394 11.2499C4.83413 9.2099 5.46874 7.46431 6.86778 6.01319C8.26682 4.56208 9.99839 3.83653 12.0625 3.83653C13.7964 3.83653 15.3265 4.37299 16.6526 5.44591C17.9787 6.5188 18.7836 7.90781 19.0673 9.61294C17.2916 9.5921 15.651 9.12576 14.1454 8.21391C12.6398 7.30205 11.484 6.05206 10.6779 4.46394C10.3606 6.01842 9.6955 7.3926 8.68269 8.5865C7.66985 9.7804 6.43027 10.6682 4.96394 11.2499Z"
            stroke="white"
            strokeWidth="0.5"
          />
        </svg>

    ),
  };

  const Debugger = {
    name: "Debugger",
    arName: "دعم تكنولوجيا المعلومات الذكية",
    path: "/debugger",
    icon: (
        <svg
          width="24"
          height="22"
          viewBox="0 0 25 23"
          fill="white"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.2308 21.6249V19.75H20.3653C20.4695 19.75 20.5597 19.7179 20.6358 19.6538C20.7119 19.5897 20.75 19.5056 20.75 19.4014V10.6586C20.75 8.26918 19.895 6.25756 18.1851 4.62375C16.4751 2.98996 14.4134 2.17306 12 2.17306C9.58651 2.17306 7.52481 2.98996 5.81487 4.62375C4.10494 6.25756 3.24997 8.26918 3.24997 10.6586V18.0192H2.3125C1.71315 18.0192 1.19873 17.8104 0.76925 17.393C0.33975 16.9755 0.125 16.4671 0.125 15.8678V13.4399C0.125 13.0344 0.240386 12.663 0.471156 12.3257C0.701927 11.9884 1.00321 11.7171 1.375 11.512L1.43272 9.91584C1.53526 8.55528 1.88861 7.29488 2.49278 6.13463C3.09695 4.97436 3.87178 3.96433 4.81728 3.10456C5.7628 2.24479 6.85415 1.57493 8.09131 1.09497C9.3285 0.61499 10.6314 0.375 12 0.375C13.3686 0.375 14.6682 0.61499 15.899 1.09497C17.1298 1.57493 18.2211 2.24159 19.173 3.09497C20.125 3.94832 20.8998 4.95513 21.4975 6.11538C22.0953 7.27563 22.4518 8.53604 22.5672 9.89663L22.6249 11.4615C22.9887 11.633 23.288 11.8782 23.5228 12.1971C23.7575 12.516 23.8749 12.8718 23.8749 13.2644V16.0553C23.8749 16.4479 23.7575 16.8036 23.5228 17.1225C23.288 17.4415 22.9887 17.6866 22.6249 17.8581V19.4014C22.6249 20.0168 22.4042 20.5412 21.9627 20.9747C21.5212 21.4082 20.9887 21.6249 20.3653 21.6249H11.2308ZM8.49038 13.2115C8.18429 13.2115 7.92348 13.1077 7.70794 12.9002C7.4924 12.6927 7.38463 12.4359 7.38463 12.1298C7.38463 11.8237 7.4924 11.5649 7.70794 11.3533C7.92348 11.1418 8.18429 11.036 8.49038 11.036C8.79646 11.036 9.05727 11.1418 9.27281 11.3533C9.48835 11.5649 9.59613 11.8237 9.59613 12.1298C9.59613 12.4359 9.48835 12.6927 9.27281 12.9002C9.05727 13.1077 8.79646 13.2115 8.49038 13.2115ZM15.5096 13.2115C15.2035 13.2115 14.9427 13.1077 14.7271 12.9002C14.5116 12.6927 14.4038 12.4359 14.4038 12.1298C14.4038 11.8237 14.5116 11.5649 14.7271 11.3533C14.9427 11.1418 15.2035 11.036 15.5096 11.036C15.8156 11.036 16.0765 11.1418 16.292 11.3533C16.5075 11.5649 16.6153 11.8237 16.6153 12.1298C16.6153 12.4359 16.5075 12.6927 16.292 12.9002C16.0765 13.1077 15.8156 13.2115 15.5096 13.2115ZM4.96394 11.2499C4.83413 9.2099 5.46874 7.46431 6.86778 6.01319C8.26682 4.56208 9.99839 3.83653 12.0625 3.83653C13.7964 3.83653 15.3265 4.37299 16.6526 5.44591C17.9787 6.5188 18.7836 7.90781 19.0673 9.61294C17.2916 9.5921 15.651 9.12576 14.1454 8.21391C12.6398 7.30205 11.484 6.05206 10.6779 4.46394C10.3606 6.01842 9.6955 7.3926 8.68269 8.5865C7.66985 9.7804 6.43027 10.6682 4.96394 11.2499Z"
            stroke="white"
            strokeWidth="0.5"
          />
        </svg>

    ),
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center w-full h-full">
        {error}
      </div>
    );
  }

  // Add home route to the beginning of the routes array
  const allRoutes = [
    homeRoute,
    SmartItSupport,
    Debugger,
    ...routes.filter((route) => !Omitted.includes(route.name)),
  ];

  return (
    <aside className="absolute bg-[#1552b2] left-0 top-0 z-50 flex xl:w-[18%] lg:w-[25%] flex-col lg:border-r-2 overflow-y-auto duration-300 ease-linear dark:bg-boxdark lg:static lg:translate-x-0">
      <div className="flex flex-row items-center justify-center gap-2 my-5">
        <NavLink to="/home">
          <p className="hidden text-white lg:block text-[30px] font-bold tracking-wider">
            Mandoobee
          </p>
        </NavLink>
      </div>

      <div className="hidden lg:flex flex-col overflow-y-auto sidebar duration-300 ease-linear">
        <div>
          <nav className="h-auto mb-8">
            <ul className="flex flex-col gap-1 leading-[42px]">
              {allRoutes.map((item, index) => (
                <Link
                  to={`/home${item.path}`}
                  key={index}
                  onClick={() => setSelectedItem(index)}
                >
                  <div
                    className={`group relative border-l-4 px-4 font-medium duration-300 ease-in-out hover:border-white
                      ${
                        selectedItem === index
                          ? `${sidebarborder}`
                          : "border-transparent"
                      }`}
                  >
                    <div
                      className={`flex  gap-2.5 ${
                        item.name === "Charting and Diagramming"
                          ? "items-start "
                          : "items-center"
                      }`}
                    >
                      <div
                        className={`sidebar-icon ${
                          typeof item.icon === "string" &&
                          iconFill.some((path) => item.icon.includes(path))
                            ? "sidbar-fill"
                            : ""
                        }`}
                      >
                        {typeof item.icon === "string" ? (
                          <ReactSVG
                            src={`${baseUrl1}/${item.icon}`}
                            beforeInjection={(svg) => {
                              svg.classList.add("w-6", "h-6");
                            }}
                          />
                        ) : (
                          <span className={`${item.name === "Charting and Diagramming" ? 'mt-2' : 'mt-0'}`}>{item.icon}</span>
                        )}
                      </div>
                      <span className="text-white">
                        {i18n.language === "ar" ? item.arName : item.name}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
